import React from "react";
import api from "../../api/config";
import { useParams } from "react-router-dom";

const ImagePreview = ({ imagesURL, setImagesURL }) => {

  const params = useParams()

  const spaceFeedId = params?.type
  const removeImage = async (id, index) => {
    try {
      await api.post("/delete-space-feed-media", {
        spaceFeedId: spaceFeedId,
        mediaIds: [id],
      });
      const updatedImages = imagesURL.filter((_, i) => i !== index);
      setImagesURL(updatedImages);
    } catch (error) {
      console.error("Error removing image:", error);
    }
  };
  console.log(imagesURL,"imagesURL")
  return (
    <div className="container">
      <div className="row">
        {imagesURL.map((image, index) => (
          <div className="col-md-3" key={index}>
            <div className="image-preview" style={{ position: "relative" }}>
              {image?.url?.includes("mp4") ? (
                <video
                  type="video/mp4"
                  src={image?.url}
                  alt="Card cap"
                  controls
                  style={{ width: "100%", height: "auto", maxHeight: "300px" }}
                />
              ) : (
                <img
                  src={
                    image?.url || "https://picsum.photos/seed/picsum/200/200"
                  }
                  alt="Card cap"
                  style={{ width: "100%", height: "auto", maxHeight: "300px" }}
                />
              )}
              <button
                className="btn btn-danger"
                onClick={() => removeImage(image?.id, index)}
                style={{ position: "absolute", top: 0, right: 0 }}
              >
                X
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImagePreview;
